export const practicePermission = ["createpractice", "viewpractice", "editpractice", "deletepractice"];
export const advisorPermission = ["createadviser", "viewadviser", "editadviser", "deleteadviser"];
export const clientPermission = ["createclients", "editclients", "viewclients", "deleteclients"];
export const companyPermission = ["viewportal", "createportal", "editportal", "deleteportal"];
